function typewriterEffect(element, htmlContent, speed = 2) {
  gsap.killTweensOf(element);
  
  if (element._typewriterProgress) {
    gsap.killTweensOf(element._typewriterProgress);
    delete element._typewriterProgress;
  }
  
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;
  const textContent = tempDiv.textContent || tempDiv.innerText || '';
  const chars = textContent.split('');
  
  if (chars.length === 0) {
    element.innerHTML = htmlContent;
    return gsap.to({}, { duration: 0 });
  }
  
  const totalDuration = chars.length * (speed / 1000);
  const progress = { value: 0 };
  element._typewriterProgress = progress;
  
  gsap.killTweensOf(progress);
  
  const parser = new DOMParser();
  const templateDoc = parser.parseFromString(htmlContent, 'text/html');
  
  function findLastTextNode(node) {
    let lastTextNode = null;
    function traverse(n) {
      if (n.nodeType === Node.TEXT_NODE) {
        const text = n.textContent.trim();
        if (text) lastTextNode = n;
      }
      for (let child of n.childNodes) {
        traverse(child);
      }
    }
    traverse(node);
    return lastTextNode;
  }
  
  const lastTextNode = findLastTextNode(templateDoc.body);
  
  if (!lastTextNode) {
    element.innerHTML = htmlContent;
    return gsap.to({}, { duration: 0 });
  }
  
  const originalText = lastTextNode.textContent;
  
  let lastDisplayedIndex = -1;
  
  element.innerHTML = '';
  progress.value = 0;
  
  const tween = gsap.to(progress, {
    value: chars.length,
    duration: totalDuration,
    ease: 'none',
    onUpdate: function() {
      const currentIndex = Math.floor(progress.value);
      
      if (currentIndex === lastDisplayedIndex || currentIndex < 0) {
        return;
      }
      
      lastDisplayedIndex = currentIndex;
      
      if (currentIndex === 0) {
        element.innerHTML = '';
        return;
      }
      
      const displayText = chars.slice(0, currentIndex).join('');
      
      const workingDoc = parser.parseFromString(htmlContent, 'text/html');
      const workingLastTextNode = findLastTextNode(workingDoc.body);
      
      if (workingLastTextNode) {
        workingLastTextNode.textContent = displayText;
        element.innerHTML = workingDoc.body.innerHTML;
      }
    },
    onComplete: function() {
      element.innerHTML = htmlContent;
    }
  });
  
  return tween;
}

function resetAnimationStates(container) {
  const imageContainer = container.querySelector('.aomai-featured-product-content-container-image');
  const imageBg = container.querySelector('.aomai-featured-product-image-bg');
  const imageImg = container.querySelector('.aomai-featured-product-image-img');
  const descriptionEl = container.querySelector('.aomai-featured-product-content-container-description');
  const titleH2 = container.querySelector('.aomai-featured-product-header__item-title h2');
  const flavorEl = container.querySelector('.aomai-featured-product-header__item-flavor');
  const claimsItems = container.querySelectorAll('.aomai-featured-product-content-container-claims-item');

  if (titleH2) {
    gsap.set(titleH2, { opacity: 0, clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)' });
  }
  if (flavorEl) {
    gsap.set(flavorEl, { opacity: 0, scale: 0.8, y: 20, clipPath: 'inset(0% 50% 0% 50%)' });
  }
  if (imageContainer) {
    gsap.set(imageContainer, { opacity: 0, scale: 0.95 });
  }
  if (imageBg) {
    gsap.set(imageBg, { opacity: 0, scale: 0.95 });
  }
  if (imageImg) {
    gsap.set(imageImg, { opacity: 0, y: 40 });
  }
  if (descriptionEl) {
    const originalHTML = descriptionEl.dataset.html || descriptionEl.innerHTML;
    descriptionEl.innerHTML = '';
    gsap.set(descriptionEl, { opacity: 0 });
  }
  
  claimsItems.forEach((claim) => {
    gsap.set(claim, { opacity: 0, scale: 0.5, y: 20 });
  });
}

function createFeaturedProductAnimation(container, options = {}) {
  const {
    typewriterSpeed = 8,
    backgroundDelay = 0,
    backgroundDuration = 0.8,
    imageDelay = 0.2,
    imageDuration = 1,
    textDelay = 0.5
  } = options;
  
  const blockId = container.dataset.blockId || 'default';

  const imageContainer = container.querySelector('.aomai-featured-product-content-container-image');
  const imageBg = container.querySelector('.aomai-featured-product-image-bg');
  const imageImg = container.querySelector('.aomai-featured-product-image-img');
  const descriptionEl = container.querySelector('.aomai-featured-product-content-container-description');
  const titleH2 = container.querySelector('.aomai-featured-product-header__item-title h2');
  const flavorEl = container.querySelector('.aomai-featured-product-header__item-flavor');

  if (!imageContainer || !imageBg || !imageImg || !descriptionEl) {
    return null;
  }

  const originalHTML = descriptionEl.dataset.html || descriptionEl.innerHTML.trim() || '';

  const timelineId = `timeline-${blockId}-${Date.now()}`;
  const timeline = gsap.timeline({ paused: true, id: timelineId });

  timeline.addLabel('titleStart');

  if (titleH2) {
    timeline.fromTo(titleH2,
      {
        opacity: 0,
        clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)'
      },
      {
        opacity: 1,
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
        duration: 1,
        ease: 'power3.inOut'
      },
      'titleStart'
    );
  }

  if (flavorEl) {
    timeline.fromTo(flavorEl,
      {
        opacity: 0,
        scale: 0.8,
        y: 20,
        clipPath: 'inset(0% 50% 0% 50%)'
      },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.8,
        ease: 'back.out(1.4)'
      },
      'titleStart+=0.4'
    );
  }

  timeline.addLabel('imageStart', 'titleStart+=0.6');

  timeline.fromTo(imageContainer,
    {
      opacity: 0,
      scale: 0.95
    },
    {
      opacity: 1,
      scale: 1,
      duration: backgroundDuration,
      ease: 'power2.out'
    },
    `imageStart+=${backgroundDelay}`
  );

  timeline.fromTo(imageBg,
    {
      opacity: 0,
      scale: 0.95
    },
    {
      opacity: 1,
      scale: 1,
      duration: backgroundDuration,
      ease: 'power2.out'
    },
    `imageStart+=${backgroundDelay}`
  );

  timeline.fromTo(imageImg,
    {
      opacity: 0,
      y: 40
    },
    {
      opacity: 1,
      y: 0,
      duration: imageDuration,
      ease: 'power3.out'
    },
    `imageStart+=${imageDelay}`
  );

  timeline.addLabel('textStart', `imageStart+=${textDelay}`);

  timeline.call(() => {
    gsap.killTweensOf(descriptionEl);
    descriptionEl.innerHTML = '';
    gsap.set(descriptionEl, { opacity: 1 });
  }, null, 'textStart');

  const claimsItems = container.querySelectorAll('.aomai-featured-product-content-container-claims-item');
  const claimsCount = claimsItems.length;
  
  if (originalHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = originalHTML;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    const chars = textContent.split('');
    const typewriterDuration = chars.length * (typewriterSpeed / 1000);
    
    const typewriterTimeline = typewriterEffect(descriptionEl, originalHTML, typewriterSpeed);
    timeline.add(typewriterTimeline, 'textStart');
    
    if (claimsCount > 0 && typewriterDuration > 0) {
      const intervalBetweenClaims = typewriterDuration / (claimsCount + 1);
      
      claimsItems.forEach((claim, index) => {
        const delay = intervalBetweenClaims * (index + 1);
        timeline.fromTo(claim,
          {
            opacity: 0,
            scale: 0.5,
            y: 20
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.4,
            ease: 'back.out(1.5)'
          },
          `textStart+=${delay}`
        );
      });
    }
  } else {
    timeline.call(() => {
      descriptionEl.style.opacity = '1';
    }, null, 'textStart');
    
    if (claimsCount > 0) {
      claimsItems.forEach((claim, index) => {
        timeline.fromTo(claim,
          {
            opacity: 0,
            scale: 0.5,
            y: 20
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.4,
            ease: 'back.out(1.5)'
          },
          `textStart+=${index * 0.2}`
        );
      });
    }
  }

  return timeline;
}

function initializeFeaturedProductSlider(container) {
  const sliderWrapper = container.querySelector('.aomai-featured-products-slider-wrapper');
  const sliderTrack = container.querySelector('.aomai-featured-products-slider-track');
  const blocks = container.querySelectorAll('.aomai-featured-product-block:not(.aomai-slide-clone)');
  const prevBtn = container.querySelector('.aomai-featured-products-slider-prev');
  const nextBtn = container.querySelector('.aomai-featured-products-slider-next');
  const dotsContainer = container.querySelector('.aomai-featured-products-slider-dots');
  
  if (!sliderWrapper || !sliderTrack || blocks.length === 0) {
    return null;
  }
  
  const totalSlides = blocks.length;
  const slideWidth = sliderWrapper.offsetWidth;
  
  blocks.forEach((block) => {
    const cloneLast = block.cloneNode(true);
    cloneLast.classList.add('aomai-slide-clone');
    sliderTrack.appendChild(cloneLast);
  });
  for (let i = blocks.length - 1; i >= 0; i--) {
    const cloneFirst = blocks[i].cloneNode(true);
    cloneFirst.classList.add('aomai-slide-clone');
    sliderTrack.insertBefore(cloneFirst, sliderTrack.firstChild);
  }
  
  const allSlides = sliderTrack.querySelectorAll('.aomai-featured-product-block');
  
  let currentSlide = totalSlides;
  
  blocks.forEach((block) => {
    resetAnimationStates(block);
  });
  
  const timelines = new Map();
  const animatedSlides = new Set();
  let hasAnimated = false;
  
  function normalizeSlideIndex(index) {
    let n = index;
    while (n < 0) n += totalSlides * 3;
    while (n >= totalSlides * 3) n -= totalSlides * 3;
    return n;
  }

  function getRealSlideIndex(index) {
    const normalized = normalizeSlideIndex(index);
    return normalized % totalSlides;
  }
  
  function getOriginalBlock(index) {
    const realIndex = getRealSlideIndex(index);
    return blocks[realIndex];
  }
  
  function showFinalState(block) {
    const titleH2 = block.querySelector('.aomai-featured-product-header__item-title h2');
    const flavorEl = block.querySelector('.aomai-featured-product-header__item-flavor');
    const imageContainer = block.querySelector('.aomai-featured-product-content-container-image');
    const imageBg = block.querySelector('.aomai-featured-product-image-bg');
    const imageImg = block.querySelector('.aomai-featured-product-image-img');
    const descriptionEl = block.querySelector('.aomai-featured-product-content-container-description');
    const claimsItems = block.querySelectorAll('.aomai-featured-product-content-container-claims-item');
    
    if (titleH2) {
      gsap.set(titleH2, { opacity: 1, clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' });
    }
    if (flavorEl) {
      gsap.set(flavorEl, { opacity: 1, scale: 1, y: 0, clipPath: 'inset(0% 0% 0% 0%)' });
    }
    if (imageContainer) {
      gsap.set(imageContainer, { opacity: 1, scale: 1 });
    }
    if (imageBg) {
      gsap.set(imageBg, { opacity: 1, scale: 1 });
    }
    if (imageImg) {
      gsap.set(imageImg, { opacity: 1, y: 0 });
    }
    if (descriptionEl) {
      const originalHTML = descriptionEl.dataset.html || '';
      if (originalHTML) {
        descriptionEl.innerHTML = originalHTML;
      }
      gsap.set(descriptionEl, { opacity: 1 });
    }
    claimsItems.forEach((claim) => {
      gsap.set(claim, { opacity: 1, scale: 1, y: 0 });
    });
  }
  
  function handleSlideChange(shouldAnimate = true) {
    currentSlide = normalizeSlideIndex(currentSlide);
    const realIndex = getRealSlideIndex(currentSlide);
    const visibleSlide = allSlides[currentSlide];
    const currentBlock = visibleSlide || getOriginalBlock(currentSlide);
    if (!currentBlock) return;
    const blockId = currentBlock.dataset.blockId;
    
    if (animatedSlides.has(blockId)) {
      showFinalState(currentBlock);
      updateDots(currentSlide);
      updateArrowsColor(currentSlide);
      return;
    }
    
    if (!shouldAnimate && !hasAnimated) {
      showFinalState(currentBlock);
      updateDots(currentSlide);
      updateArrowsColor(currentSlide);
      return;
    }
    
    timelines.forEach((timeline, id) => {
      timeline.clear();
      timeline.kill();
    });
    timelines.clear();
    
    const animatedElements = [
      currentBlock.querySelector('.aomai-featured-product-header__item-title h2'),
      currentBlock.querySelector('.aomai-featured-product-header__item-flavor'),
      currentBlock.querySelector('.aomai-featured-product-content-container-image'),
      currentBlock.querySelector('.aomai-featured-product-image-bg'),
      currentBlock.querySelector('.aomai-featured-product-image-img'),
      currentBlock.querySelector('.aomai-featured-product-content-container-description'),
      ...currentBlock.querySelectorAll('.aomai-featured-product-content-container-claims-item')
    ].filter(Boolean);
    
    animatedElements.forEach((el) => {
      gsap.killTweensOf(el);
      gsap.set(el, { clearProps: 'opacity,transform,clipPath' });
    });
    
    gsap.killTweensOf(currentBlock);
    
    const descriptionEl = currentBlock.querySelector('.aomai-featured-product-content-container-description');
    if (descriptionEl) {
      gsap.killTweensOf(descriptionEl);
      descriptionEl.innerHTML = '';
      gsap.set(descriptionEl, { opacity: 0, clearProps: 'opacity,transform' });
      if (descriptionEl._gsapProgress) {
        gsap.killTweensOf(descriptionEl._gsapProgress);
        delete descriptionEl._gsapProgress;
      }
      if (descriptionEl._typewriterProgress) {
        gsap.killTweensOf(descriptionEl._typewriterProgress);
        delete descriptionEl._typewriterProgress;
      }
    }
    
    resetAnimationStates(currentBlock);
    
    const claimsItems = currentBlock.querySelectorAll('.aomai-featured-product-content-container-claims-item');
    claimsItems.forEach((claim) => {
      gsap.set(claim, { opacity: 0, scale: 0.5, y: 20, clearProps: 'opacity,transform' });
    });
    
    const newTimeline = createFeaturedProductAnimation(currentBlock);
    if (newTimeline) {
      timelines.set(blockId, newTimeline);
      animatedSlides.add(blockId);
      hasAnimated = true;
      requestAnimationFrame(() => {
        newTimeline.play(0);
      });
    }
    
    updateDots(currentSlide);
    updateArrowsColor(currentSlide);
  }
  
  function createDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('button');
      dot.className = 'aomai-featured-products-slider-dot';
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('aria-label', `Ir para slide ${i + 1}`);
      dot.addEventListener('click', () => {
        const targetIndex = totalSlides + i;
        const direction = targetIndex > currentSlide ? 1 : -1;
        const steps = Math.abs(targetIndex - currentSlide);
        let stepCount = 0;
        const stepInterval = setInterval(() => {
          goToSlide(direction, stepCount === steps - 1);
          stepCount++;
          if (stepCount >= steps) {
            clearInterval(stepInterval);
          }
        }, 100);
      });
      dotsContainer.appendChild(dot);
    }
  }
  
  function updateDots(index) {
    const realIndex = getRealSlideIndex(index);
    const dots = dotsContainer.querySelectorAll('.aomai-featured-products-slider-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === realIndex);
    });
  }
  
  function updateArrowsColor(index) {
    const realIndex = getRealSlideIndex(index);
    const currentBlock = blocks[realIndex];
    const textColor = currentBlock.dataset.textColor || '#505050';
    
    const prevSvg = prevBtn?.querySelector('svg path');
    const nextSvg = nextBtn?.querySelector('svg path');
    
    if (prevSvg) {
      gsap.to(prevSvg, {
        attr: { stroke: textColor },
        duration: 0.3,
        ease: 'power2.out'
      });
    }
    if (nextSvg) {
      gsap.to(nextSvg, {
        attr: { stroke: textColor },
        duration: 0.3,
        ease: 'power2.out'
      });
    }
  }
  
  function updateButtons(index) {
    if (prevBtn) {
      prevBtn.disabled = false;
    }
    if (nextBtn) {
      nextBtn.disabled = false;
    }
  }
  
  function goToSlide(direction, animate = true) {
    currentSlide += direction;
    
    const offsetX = -currentSlide * slideWidth;
    
    if (animate) {
      gsap.to(sliderTrack, {
        x: offsetX,
        duration: 0.8,
        ease: 'power3.inOut',
        onComplete: () => {
          if (currentSlide <= 0) {
            currentSlide = totalSlides * 2;
            gsap.set(sliderTrack, { x: -currentSlide * slideWidth, immediateRender: false });
          } else if (currentSlide >= totalSlides * 3) {
            currentSlide = totalSlides;
            gsap.set(sliderTrack, { x: -currentSlide * slideWidth, immediateRender: false });
          }
          
          handleSlideChange(true);
        }
      });
    } else {
      if (currentSlide <= 0) {
        currentSlide = totalSlides * 2;
      } else if (currentSlide >= totalSlides * 3) {
        currentSlide = totalSlides;
      }
      
      gsap.set(sliderTrack, { x: -currentSlide * slideWidth });
      handleSlideChange(true);
    }
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      goToSlide(-1);
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      goToSlide(1);
    });
  }
  
  createDots();
  updateButtons(0);
  updateArrowsColor(currentSlide);
  
  gsap.set(sliderTrack, { x: -currentSlide * slideWidth });
  handleSlideChange(false);
  
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  let isDragging = false;
  
  sliderWrapper.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = false;
  }, { passive: true });
  
  sliderWrapper.addEventListener('touchmove', (e) => {
    if (!touchStartX || !touchStartY) return;
    
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;
    
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;
    
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
      isDragging = true;
    }
  }, { passive: true });
  
  sliderWrapper.addEventListener('touchend', (e) => {
    if (!touchStartX || !touchStartY || !isDragging) {
      touchStartX = 0;
      touchStartY = 0;
      return;
    }
    
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;
    const minSwipeDistance = 50;
    
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
      if (deltaX > 0) {
        goToSlide(-1);
      } else {
        goToSlide(1);
      }
    }
    
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    isDragging = false;
  }, { passive: true });
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newSlideWidth = sliderWrapper.offsetWidth;
      if (newSlideWidth !== slideWidth) {
        const offsetX = -currentSlide * newSlideWidth;
        gsap.set(sliderTrack, { x: offsetX });
      }
    }, 250);
  });
  
  return {
    goToSlide,
    handleSlideChange: (shouldAnimate) => handleSlideChange(shouldAnimate),
    currentSlide: () => currentSlide,
    totalSlides: () => totalSlides
  };
}

function initializeFeaturedProductAnimations() {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP não carregado');
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  if (Shopify && Shopify.designMode) {
    return;
  }

  const containers = document.querySelectorAll('.aomai-featured-products__inner');
  const sliders = [];
  
  containers.forEach((container) => {
    const section = container.closest('.shopify-section');
    if (!section) return;
    
    const slider = initializeFeaturedProductSlider(container);
    if (slider) {
      sliders.push(slider);
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sliderInstance = slider;
            if (sliderInstance && sliderInstance.handleSlideChange) {
              sliderInstance.handleSlideChange(true);
            }
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px'
      });
      
      observer.observe(section);
    }
  });

  return sliders;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFeaturedProductAnimations);
} else {
  initializeFeaturedProductAnimations();
}

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && document.querySelector(`#shopify-section-${event.detail.sectionId} .aomai-featured-product-block`)) {
      setTimeout(initializeFeaturedProductAnimations, 100);
    }
  });
}
